import styled from 'styled-components';
import EditButton from '../../../EditButton';

const StyledSubscriptionDetailsPanel = styled.div`
  width: 100%;

  .ant-progress {
    display: flex;
    height: 6px;
  }

  .ant-progress-inner {
    border-radius: 100px !important;
  }
`;

const StyledSubscriptionDetailsPanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;


const StyledSubscriptionDetailsPanelEditButton = styled(EditButton)`
  svg {
    height: 16px;
    width: 16px;
    path {
      fill: ${props => props.theme.colors.neutral_7};
    }
  }
`;

export {
  StyledSubscriptionDetailsPanel,
  StyledSubscriptionDetailsPanelHeader,
  StyledSubscriptionDetailsPanelEditButton,
}
